import type { UserDuplicate } from "@repo/types";
import { CheckboxInput } from "@repo/ui/components/Base/CheckboxInput";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@repo/ui/components/Base/Table";
import { CheckIcon } from "lucide-react";

export type SelectionChangeHandler = (emails: string[]) => void;

export interface UsersDuplicateTableProps {
  duplicates: UserDuplicate[];
  selection: string[];
  onSelectionChange: SelectionChangeHandler;
}

export const UsersDuplicateTable = ({
  duplicates,
  selection,
  onSelectionChange,
}: UsersDuplicateTableProps) => {
  return (
    <div className="rounded-md border bg-white">
      <Table wrapperClassName="max-h-[40vh] overflow-auto">
        <UsersDuplicateTableHeader />
        <UsersDuplicateTableBody
          duplicates={duplicates}
          selection={selection}
          onSelectionChange={onSelectionChange}
        />
      </Table>
    </div>
  );
};

export const UsersDuplicateTableHeader = () => {
  return (
    <TableHeader className="sticky -top-0.5 bg-red-300">
      <TableRow>
        <TableHead className="text-foreground"></TableHead>
        <TableHead className="text-foreground">First Name</TableHead>
        <TableHead className="text-foreground">Last Name</TableHead>
        <TableHead className="text-foreground">Email</TableHead>
        <TableHead className="text-foreground">Old Role</TableHead>
        <TableHead className="text-foreground">New Role</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export interface UsersDuplicateTableBodyProps {
  duplicates: UserDuplicate[];
  selection: string[];
  onSelectionChange: SelectionChangeHandler;
}

export const UsersDuplicateTableBody = ({
  duplicates,
  selection,
  onSelectionChange,
}: UsersDuplicateTableBodyProps) => {
  return (
    <TableBody>
      {duplicates.map((dup) => {
        const isChecked = selection.includes(dup.user.email);
        const select = () => {
          const list = selection.filter((email) => email !== dup.user.email);
          list.push(dup.user.email);
          onSelectionChange(list);
        };
        const deselect = () => {
          const list = selection.filter((email) => email !== dup.user.email);
          onSelectionChange(list);
        };
        const toggle = isChecked ? deselect : select;

        return (
          <TableRow key={dup.user.email}>
            <TableCell>
              <CheckboxInput checked={isChecked} onCheckedChange={toggle} />
            </TableCell>
            <TableCell>{dup.user.firstName}</TableCell>
            <TableCell>{dup.user.lastName}</TableCell>
            <TableCell>{dup.user.email}</TableCell>
            <TableCell className="cursor-pointer" onClick={deselect}>
              {!isChecked && <CheckIcon className="inline-block" />}{" "}
              {dup.oldRole}
            </TableCell>
            <TableCell className="cursor-pointer" onClick={select}>
              {isChecked && <CheckIcon className="inline-block" />}{" "}
              {dup.newRole}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
